export const ZOOM_SETTINGS = "ZOOM_SETTINGS";
export const SET_ZOOM_SETTINGS = "SET_ZOOM_SETTINGS";
